/** Organic (non-promotional) comments an account posts before each brand reply or DM. */
export const ORGANIC_PER_BRAND = 9;
export const WARMUP_STAGES = [
    { stage: 0, label: 'Lurking', minFleetDays: 0, minOwnDays: 0, minKarma: 0, allowed: ['warmup'], caps: { warmup: 12 }, summary: 'Seasons the browser, fills the profile, browses and upvotes' },
    { stage: 1, label: 'Joining communities', minFleetDays: 4, minOwnDays: 1, minKarma: 0, allowed: ['warmup'], caps: { warmup: 20 }, summary: 'Joins its persona communities, keeps browsing and voting' },
    { stage: 2, label: 'Organic replies', minFleetDays: 7, minOwnDays: 2, minKarma: 0, allowed: ['warmup', 'organic'], caps: { warmup: 25, organic: 2 }, summary: 'Short replies to comments on fresh posts in its communities' },
    { stage: 3, label: 'Building karma', minFleetDays: 10, minOwnDays: 3, minKarma: 25, allowed: ['warmup', 'organic'], caps: { organic: 4 }, summary: 'More organic replies; contributor quality measured' },
    { stage: 4, label: 'Ready', minFleetDays: 14, minOwnDays: 3, minKarma: 150, allowed: ['warmup', 'organic', 'comment', 'followup', 'dm'], caps: {}, summary: `Brand replies unlocked, each after ${ORGANIC_PER_BRAND} organic ones` },
];
export const READY_STAGE = WARMUP_STAGES[WARMUP_STAGES.length - 1].stage;
/** A measured CQS at these levels keeps brand work off the account. */
export const CQS_BLOCKS_BRAND = ['lowest', 'low'];
/** Communities an account joins while warming (stage 1), and the most it ever joins from its persona. */
export const JOIN_TARGET = 20;
export const JOIN_MAX = 60;
/** Days between two CQS checks once the account builds karma. */
export const CQS_EVERY_DAYS = 14;
export function eligibleStage(facts) {
    let stage = 0;
    for (const candidate of WARMUP_STAGES) {
        const days = facts.own ? candidate.minOwnDays : candidate.minFleetDays;
        if (facts.fleetDays < days || facts.karma < candidate.minKarma)
            continue;
        if (candidate.stage === READY_STAGE && facts.cqs && CQS_BLOCKS_BRAND.includes(facts.cqs))
            continue;
        stage = candidate.stage;
    }
    return stage;
}
export function stageInfo(stage) {
    return WARMUP_STAGES.find((s) => s.stage === stage) ?? WARMUP_STAGES[0];
}
/** True when enough organic comments followed the last brand reply (perBrand 0 = no ratio). */
export function brandRatioMet(organicSinceBrand, perBrand) {
    return perBrand <= 0 || organicSinceBrand >= perBrand;
}
//# sourceMappingURL=warmup.js.map